interface CookiesConfig {
  secure: boolean;
}

interface TokenManagerConfig {
  storage: 'cookie' | 'localStorage' | 'sessionStorage';
  storageKey: string;
}

interface Config {
  clientId: string;
  cookies: CookiesConfig;
  devMode: boolean;
  issuer: string;
  pkce: boolean;
  redirectUri: string;
  responseType: ('token' | 'id_token')[];
  scopes: string[];
  tokenManager: TokenManagerConfig;
}

const config: Config = {
  clientId: '',
  cookies: {
    secure: true
  },
  devMode: false,
  issuer: '',
  pkce: false,
  redirectUri: '',
  responseType: ['token', 'id_token'],
  scopes: ['openid', 'profile', 'email'],
  tokenManager: {
    storage: 'cookie',
    storageKey: 'cfbRedcarpet-token-storage'
  }
};

export default config;